<template>
  <div>
    <data-tracker>{{ menuItems[6].icon }}</data-tracker>

    <!----- TEMPLATE: Headline ------>
    <headline-bar :extend-x="6" class="mb-6">
      <template v-slot:prepend-btn>
        <v-btn icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </template>

      Sandbox

      <template v-slot:btn-icon-1>
        <v-btn icon>
          <v-icon>mdi-numeric-1-circle-outline</v-icon>
        </v-btn>
      </template>

      <template v-slot:btn-icon-2>
        <v-btn icon>
          <v-icon>mdi-numeric-2-circle-outline</v-icon>
        </v-btn>
      </template>

      <template v-slot:btn-icon-3>
        <v-btn icon>
          <v-icon>mdi-numeric-3-circle-outline</v-icon>
        </v-btn>
      </template>

      <template v-slot:btn-overflow>
        <v-btn icon>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
    </headline-bar>

    <v-row>
      <v-col cols="12" sm="6" md="4" lg="3" class="d-flex flex-column">
        <v-card class="flex-grow-1">
          <!----- TEMPLATE: Card Label Bar ------>
          <card-label-bar bold-text>
            Word of the day

            <template v-slot:btn-text>
              <v-btn text color="blue"> Edit </v-btn>
            </template>

            <template v-slot:btn-icon>
              <v-btn icon>
                <v-icon>mdi-numeric-1-circle-outline</v-icon>
              </v-btn>
            </template>

            <template v-slot:btn-overflow>
              <v-btn icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
          </card-label-bar>

          <v-card-text>
            <div>Word of the Day</div>
            <p class="display-1 text--primary">el·ee·mos·y·nar·y</p>
            <p>adjective</p>
            <div class="text--primary">
              relating to or dependent on charity; charitable.<br />
              "an eleemosynary educational institution."
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="blue" @click="reveal = true">
              Click to show another card
            </v-btn>
          </v-card-actions>

          <v-expand-transition>
            <v-card
              v-if="reveal"
              class="transition-fast-in-fast-out v-card--reveal"
              style="height: 100%"
            >
              <v-card-text class="pb-0">
                <p class="display-1 text--primary">Origin</p>
                <p>
                  late 16th century (as a noun denoting a place where alms were
                  distributed): from medieval Latin eleemosynarius, from late
                  Latin eleemosyna ‘alms’, from Greek eleēmosunē ‘compassion’
                </p>
              </v-card-text>
              <v-spacer></v-spacer>
              <v-card-actions class="pt-0">
                <v-btn text color="blue" @click="reveal = false"> Close </v-btn>
              </v-card-actions>
            </v-card>
          </v-expand-transition>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="3" class="d-flex flex-column">
        <v-sheet class="pa-6 flex-grow-1">
          <v-autocomplete
            :items="regions"
            return-object
            item-text="name"
            item-value="code"
            @contextmenu.native="disableContextMenu"
            label="Regions"
            placeholder="Select ..."
            no-data-text="Region is not available"
            filled
            color="secondary"
          >
            <template v-slot:item="data">
              <v-list-item-avatar size="32">
                <v-icon size="24">${{ data.item.code }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title> {{ data.item.name }} </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>

          <p class="caption">
            Working on v-autocomplete using object of objects instead of array
            of objects
          </p>
          <!-- <v-autocomplete
            :items="regions"
            return-object
            :item-text="name"
            item-value="code"
            label="Regions"
            placeholder="Select ..."
            no-data-text="Region is not available"
            filled
            color="secondary"
          >
            <template v-slot:item="data">
              <v-list-item-avatar size="32">
                <v-icon size="24">${{ data.item.flag }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title> {{ data.item.name }} </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete> -->
        </v-sheet>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="3" class="d-flex flex-column">
        <v-sheet class="pa-6 flex-grow-1">
          <v-autocomplete
            v-model="locationInfo.timeZone.info"
            :items="regions"
            return-object
            item-text="name"
            item-value="code"
            @contextmenu.native="disableContextMenu"
            label="Regions"
            placeholder="Select ..."
            no-data-text="Region is not available"
            filled
            color="secondary"
          >
            <template v-slot:item="data">
              <v-list-item-avatar size="32">
                <v-icon size="24">${{ data.item.code }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title> {{ data.item.name }} </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-sheet>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="3" class="d-flex flex-column">
        <v-sheet class="pa-6 flex-grow-1">
          <v-autocomplete
            v-model="values"
            :items="items"
            @contextmenu.native="disableContextMenu"
            label="Filled"
            dense
            filled
          ></v-autocomplete>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" lg="6" class="d-flex flex-column">
        <v-sheet class="pa-6 flex-grow-1">
          <div class="d-flex flex-row" width="100%">
            <!-- Area code -->
            <v-text-field
              value="88"
              class="mr-4"
              single-line
              filled
              disabled
              color="secondary"
              style="max-width: 104px"
            >
              <template v-slot:prepend-inner>
                <v-icon size="20">$kr</v-icon>
              </template>
            </v-text-field>

            <!-- Phone Number -->
            <v-text-field
              v-model="mobile"
              placeholder="Mobile number"
              type="number"
              single-line
              filled
              color="secondary"
            ></v-text-field>
          </div>

          <!-- <v-btn @click="logIT" text color="blue"> Test </v-btn> -->
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Sandbox",
  data() {
    return {
      reveal: false,
      mobile: "",
      items: ["foo", "bar", "fizz", "buzz"],
      values: ["foo", "bar"],
      value: ["foo"],
    };
  },
  computed: {
    countries() {
      return this.$store.getters["Common/countries"];
    },
    regions() {
      return this.$store.getters["Regions/regions"];
    },
    locationInfo() {
      return this.$store.getters["Profile/locationInfo"];
    },
    countryCode() {
      return this.countries[this.locationInfo.country.value.toLowerCase()]
        .countryCode;
    },
    menuItems() {
      return this.$store.getters["Drawer/menuItems"];
    },
  },
  methods: {
    logIT() {
      console.log("test");
    },
  },
  mounted() {},
};
</script>

<style lang="sass" scoped>
.v-card--reveal
  bottom: 0
  opacity: 1 !important
  position: absolute
  width: 100%
</style>
